// extracted by mini-css-extract-plugin
module.exports = {"framework-selector":"G_cY d-flex","framework-selector__icon":"G_cZ","framework-selector__option":"G_c0 p-2 flex-grow-1 ml-2","framework-selector__option--selected":"G_c1"};